<template src="./archivio.html"></template>

<script>
import {
    get_file,
    get_estensioni,
    carica_file,
    getDettaglioFile,
    elimina_cartella,
} from "@/api/api.archivio.js";

import DialogAnteprima from "@/components/dialog/archivio/DialogAnteprima.vue";
import DialogCartella from "@/components/dialog/archivio/DialogCartella.vue";
import DialogSceltaSottoDirectory from "@/components/dialog/archivio/DialogSceltaSottoDirectory.vue";
import DialogRenameDirectory from "@/components/dialog/archivio/DialogRenameDirectory.vue";

export default {
    components: { DialogAnteprima, DialogCartella, DialogSceltaSottoDirectory, DialogRenameDirectory },

    data: () => ({
        file: [],
        fileSupp: [],
        countFile: 0,

        listaFiles: [],
        listaDirectories: [],
        listaSottoFiles: [],
        listaSottoDirectory: [],
        selectedItem: -1,
        selectedRow: null,

        estensioni: [],
        estensioneSel: "",
        search: "",
        opzioni: [
            { Opzione: 1, Nome: "Elimina" },
            { Opzione: 2, Nome: "Rinomina" }
        ],

        //dialog
        dialogFile: false,
        dialogDirectory: false,
        dialogSceltaSottoDirectory: false,
        dialogRenameDir: false,
        pathCartella: "",
        DirectoryRename: null,
        TipoDirectoryRename: -1,

        //drag & drop
        draggedItem: null, // Memorizza l'oggetto trascinato
        draggedIndex: null, // Memorizza l'indice dell'oggetto trascinato

        //tab
        tabs: 0,
    }),

    methods: {
        async CaricaEstensioni() {
            this.estensioni = [];

            let par = {
                filtro: "",
                path: this.listaDirectories[this.tabs].path,
            };
            let res = await get_estensioni(par);
            if (res.data.length > 0 && res.data != []) this.estensioni = res.data;
            this.estensioneSel = this.estensioni[0];
        },

        async CaricaDati() {
            //reset tutti i campi
            this.resetCampi();

            //carico dati
            let par = {
                filtro: this.estensioneSel,
                path: "",
            }
            let res = await get_file(par);
            if (res.data != null && res.data != {}) {
                this.listaFiles = res.data.files;
                this.listaDirectories = res.data.directories;
                this.listaSottoFiles = res.data.sottoFiles;

                await this.CaricaEstensioni();
            }
        },

        async CaricaDatiEstensione() {
            this.listaFiles = [];
            this.listaSottoFiles = [];
            //carico dati
            let par = {
                filtro: this.estensioneSel,
                path: this.listaDirectories[this.tabs].path,
            }
            let res = await get_file(par);
            if (res.data != null && res.data != {}) {
                this.listaFiles = res.data.files;
                this.listaSottoFiles = res.data.sottoFiles;
            }
        },

        async CaricaDatiTabFiles() {
            this.resetCampi();
            let par = {
                filtro: this.estensioneSel,
                path: this.listaDirectories[this.tabs].path,
            }
            let res = await get_file(par);
            if (res.data != null && res.data != {}) {
                this.listaFiles = res.data.files;
                this.listaSottoDirectory = res.data.directories;
                this.listaSottoFiles = res.data.sottoFiles;

                //carico estensioni file
                await this.CaricaEstensioni();
            }
        },

        setSearch() {
            this.search = "";
        },

        resetCampi() {
            this.file = [];
            this.fileSupp = [];
            this.countFile = 0;
            this.listaFiles = [];
            this.listaSottoFiles = [];
            this.listaSottoDirectory = [];
            //this.listaDirectories = [];
            this.selectedItem = -1;
            this.selectedRow = null;
            this.estensioni = [];
            this.estensioneSel = "";
            this.search = "";
            this.DirectoryRename = null;
            this.TipoDirectoryRename = -1;
            this.cartellaMadre = null;
            //this.tabs = 0;
        },

        async visualizzaFile(item, value) {
            if (item != undefined) this.selectedRow = item;
            if (this.dialogFile) {
                this.dialogFile = false;
                if (value) await this.CaricaDatiTabFiles();
            }
            else {
                let pathFinal = "";
                let path = this.selectedRow.path.split("/");
                for (let i = 0; i < path.length; i++) {
                    if (i >= 5) pathFinal = pathFinal + "/" + path[i];
                }
                let par = {
                    path: pathFinal,
                    filtro: "",
                }
                let res = await getDettaglioFile(par);
                this.selectedRow = res.data;
                this.dialogFile = true;
            }
        },

        async cercaFile() {
            if (this.search != "" && this.search != null) {
                //carico file per partire sempre con tutte le risorse
                //dato che eseguo una filter

                this.listaFiles = [];
                this.listaSottoFiles = [];
                this.listaSottoDirectory = [];

                //carico dati
                let par = {
                    filtro: this.estensioneSel,
                    path: this.listaDirectories[this.tabs].path,
                }
                let res = await get_file(par);
                if (res.data != null && res.data != {}) {
                    this.listaFiles = res.data.files;
                    this.listaSottoDirectory = res.data.directories;
                    this.listaSottoFiles = res.data.sottoFiles;
                }

                //filtro per case-insensitive
                let regex = new RegExp(this.search, "i");
                let filtrati = this.listaFiles.filter(item => regex.test(item.nome));
                this.listaFiles = [];// pulisco per sicurezza
                this.listaFiles = filtrati;

                let filtratiSottoFile = this.listaSottoFiles.filter(item => regex.test(item.nome));
                this.lislistaSottoFilestaFiles = [];// pulisco per sicurezza
                this.listaSottoFiles = filtratiSottoFile;

                this.$refs.txtCerca.focus();

            }
        },

        async uploadFile() {
            let upload = false;

            for (let i = 0; i < this.fileSupp.length; i++) {
                let par = ""; let path = "";
                let formData = new FormData();

                formData.append("file", this.file[i]);
                path = this.controlloPathFileCaricato(this.listaDirectories[this.tabs].path + "/" + this.file[i].name)
                par = "?path=" + encodeURIComponent(path)
                let res = await carica_file(formData, par);

                if (res.data != "OK") {
                    upload = true;
                    this.$toast.alert("Errore nel caricamento del file " + this.file[0].nome);
                    break;
                }
            }

            if (!upload) {
                this.$toast.info("File caricato/i correttamente.");
                await this.CaricaDatiTabFiles();
            }
        },

        controlloPathFileCaricato(path) {
            let url = path.split("/");
            //if (url[url.length - 1].includes(".")) url.pop();
            path = url.join("/");
            return path;
        },

        /* Drag & Drop v-file-input*/
        startDrag(event, item, index) {
            this.draggedItem = item; //elemento trascinato
            this.draggedIndex = index; //indice originale
            event.dataTransfer.effectAllowed = "move";
            event.dataTransfer.setData("itemData", JSON.stringify(item));
        },

        onDrop(event, dropIndex) {
            event.preventDefault();

            if (this.draggedItem === null || this.draggedIndex === dropIndex) return;

            //rimuovi elemento dalla posizione originale
            this.listaFiles.splice(this.draggedIndex, 1);

            //inserisco elemento nella nuova posizione
            this.listaFiles.splice(dropIndex, 0, this.draggedItem);

            this.draggedItem = null;
        },

        onDragOver(event) {
            event.dataTransfer.dropEffect = "copy";
        },

        onDropFile(event) {
            let droppedFiles = null; let fileTrascinato = null;
            droppedFiles = event.dataTransfer.files;

            if (droppedFiles.length) {
                fileTrascinato = droppedFiles[0];
                this.file.push(fileTrascinato);
            }

            this.$refs.txtFile.focus();

            if (this.listaSottoDirectory.length > 0) this.chiudiDialogSceltaDirectory();
        },

        /* Drag & Drop v-tabs*/
        onDropFileDir(event, tabs) {
            let droppedFiles = null; let fileTrascinato = null;
            droppedFiles = event.dataTransfer.files;

            if (droppedFiles.length) {
                fileTrascinato = droppedFiles[0];
                this.file.push(fileTrascinato);
            }

            //eseguo caricamento automatico del file
            this.CaricaFileDragDrop(tabs);

            this.$refs.txtFile.focus();
        },

        async CaricaFileDragDrop(tabs) {
            //carico file
            let upload = false;

            if (this.listaSottoDirectory.length <= 0) {
                let par = "";
                let formData = new FormData();

                formData.append("file", this.file[0]);
                par = "?path=" + encodeURIComponent(this.listaDirectories[tabs].path + "/" + this.file[0].name)
                let res = await carica_file(formData, par);

                if (res.data != "OK") {
                    upload = true;
                    this.$toast.alert("Errore nel caricamento del file " + this.file[0].nome);
                }

                if (!upload) {
                    this.$toast.info("File caricato correttamente.");
                    await this.CaricaDatiTabFiles();
                }
            }
            else
                //faccio scegliere all'utente dove andare a inserire il file
                //tra le sottocartelle se ce ne sono
                this.chiudiDialogSceltaDirectory();
        },

        async chiudiDialogSceltaDirectory(value, directorySel) {
            if (this.dialogSceltaSottoDirectory) {
                if (value == false) {
                    this.file = [];
                    this.fileSupp = [];
                } else {
                    let upload = false;
                    //carico file
                    let par = "";
                    let formData = new FormData();

                    formData.append("file", this.file[0]);
                    if (directorySel != "") par = "?path=" + encodeURIComponent(this.listaDirectories[this.tabs].path + "/" + directorySel + "/" + this.file[0].name)
                    else par = "?path=" + encodeURIComponent(this.listaDirectories[this.tabs].path + "/" + this.file[0].name)
                    let res = await carica_file(formData, par);

                    if (res.data != "OK") {
                        upload = true;
                        this.$toast.alert("Errore nel caricamento del file " + this.file[0].nome);
                    }

                    if (!upload) {
                        this.$toast.info("File caricato correttamente.");
                        await this.CaricaDatiTabFiles();
                    }
                }
                this.dialogSceltaSottoDirectory = false;
            }
            else this.dialogSceltaSottoDirectory = true;
        },

        async chiudiDialog(value) {
            if (this.dialogDirectory) {
                this.dialogDirectory = false;

                if (value == undefined) return;
                else {
                    //controllo se ricaricare tutto o una determinata cartella
                    if (value == 0) {
                        this.tabs = 0;
                        await this.CaricaDati();
                    }
                    if (value == 1) await this.CaricaDatiTabFiles();
                }
            }
            else {
                this.pathCartella = this.listaDirectories[this.tabs].path;
                this.dialogDirectory = true;
            }
        },

        async EliminaDirectory(directory, dir) {
            let confirm = await this.$confirm.open(
                "Elimina",
                "Eliminare la certella: <br><b>" + directory.nome + "</b>?<br><br>Tutte le risorse al suo interno andranno perse."
            );
            if (!confirm) return;



            let par = "?path=" + encodeURIComponent(directory.path)
            let res = await elimina_cartella(par);

            if (res.data == "OK") {
                this.$toast.info("Cartella eliminata con successo.");

                if (dir == 0) {
                    this.tabs = 0; //serve per ricaricare tutto
                    await this.CaricaDati();
                }
                if (dir == 1) await this.CaricaDatiTabFiles()
            }
            else {
                this.$toast.alert("Errore nell'eliminazione della cartella " + directory.nome);

            }
        },

        SelectOpzioneMenu(item) {
            if (item.Opzione == 1) this.EliminaDirectory(this.listaDirectories[this.tabs], 0);
            if (item.Opzione == 2) this.renameDirectory(this.listaDirectories[this.tabs], 0);
        },

        renameDirectory(directory, value) {
            if (this.dialogRenameDir) {
                this.DirectoryRename = null;
                this.TipoDirectoryRename = -1;
                this.dialogRenameDir = false;
                //controllo se ricaricare tutto o solo una determinata cartella
                if (value == 0) {
                    this.tabs = 0;
                    this.CaricaDati();
                }
                if (value == 1) this.CaricaDatiTabFiles();
            }
            else {
                this.DirectoryRename = directory;
                this.TipoDirectoryRename = value;
                this.dialogRenameDir = true;
            }
        },
    },

    async mounted() {
        await this.CaricaDati();
    },

    watch: {
        file(newVal) {
            if (newVal.length > 0) {
                this.countFile++;
                //controllo se si aggiunge il file in drag & drop o con singolo click
                if (newVal.length <= 1) this.fileSupp.push(this.file[0]);
                else {
                    this.fileSupp = [];
                    this.fileSupp = this.file
                }
                //if (this.listaSottoDirectory.length > 0) this.chiudiDialogSceltaDirectory();
            }
            else {
                this.countFile = 0;
                this.fileSupp = [];
            }
        },
        async tabs() {
            //carico dati della cartella selezionata
            await this.CaricaDatiTabFiles();
        },
        async search(newVal) {
            if (newVal == "" || newVal == null) await this.CaricaDatiTabFiles();
        },
    },
};
</script>

<style scoped>
.zoom-card {
    transition: transform 0.3s ease;
}

.zoom-card:hover {
    transform: scale(1.1);
}
</style>